import { render, staticRenderFns } from "./VerificationNotification.vue?vue&type=template&id=2e5188d7&scoped=true&"
import script from "./VerificationNotification.vue?vue&type=script&lang=ts&"
export * from "./VerificationNotification.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationNotification.vue?vue&type=style&index=0&id=2e5188d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5188d7",
  null
  
)

export default component.exports